import React from "react";
import PropTypes from "prop-types";
import { Table, Button, Input } from "reactstrap";

const ScannerList = React.memo(({
    couponScanner,
    onUpdate,
    couponsData = {},
    websiteUrls = {},
    siteUrl = {},
    handleInputChange
}) => {
    if (!couponScanner || couponScanner.length === 0) {
        return (
            <div className="d-flex justify-content-center py-4">
                <p>No coupon scanner found</p>
            </div>
        );
    }

    return (
        <Table striped>
            <thead>
                <tr>
                    <th style={{ width: '5%' }}>ID</th>
                    <th style={{ width: '10%' }}>Name</th>
                    <th style={{ width: '25%' }}>Coupons</th>
                    <th style={{ width: '25%' }}>Client Visible URL</th>
                    <th style={{ width: '25%' }}>Website URLs</th>
                    <th style={{ width: '10%' }}>Action</th>
                </tr>
            </thead>
            <tbody>
                {couponScanner.map(({ id, name }, index) => (
                    <tr key={id}>
                        <td>{index + 1}</td>
                        <td>{name}</td>
                        <td>
                            <Input
                                type="textarea"
                                name={`coupons_${id}`}
                                placeholder="Write here coupon codes with comma separator"
                                value={couponsData[`coupons_${id}`] || ''}
                                onChange={handleInputChange}
                                className="form-control"
                                rows="3"
                            />
                        </td>
                        <td>
                            <Input
                                type="textarea"
                                name={`site_url_${id}`}
                                placeholder="Write here client visible url"
                                value={siteUrl[`site_url_${id}`] || ''}
                                onChange={handleInputChange}
                                className="form-control"
                                rows="3"
                            />
                        </td>
                        <td>
                            <Input
                                type="textarea"
                                name={`website_urls_${id}`}
                                placeholder="Write website urls with comma separator"
                                value={websiteUrls[`website_urls_${id}`] || ''}
                                onChange={handleInputChange}
                                className="form-control"
                                rows="3"
                            />
                        </td>
                        <td>
                            <Button
                                color="primary"
                                onClick={() => onUpdate(id)}
                            >
                                Update
                            </Button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
});

ScannerList.propTypes = {
    couponScanner: PropTypes.array.isRequired,
    onUpdate: PropTypes.func.isRequired,
    websiteUrls: PropTypes.object,
    couponsData: PropTypes.object,
    siteUrl: PropTypes.object,
    handleInputChange: PropTypes.func.isRequired,
};

ScannerList.displayName = 'ScannerList';

export default ScannerList;